import { createReducer, on } from '@ngrx/store';

import * as AppActions from './app.actions';
import { Company } from '../../../core/domain/company/company';

export interface AppState {
  sideMenuMinimized: boolean;
  isAModalOpen: boolean;
  currentCompany: string | null;
  userCompanies: Company[];
  isSelectCompanyModalOpen: boolean;
}

export const initialState: AppState = {
  sideMenuMinimized: false,
  isAModalOpen: false,
  currentCompany: null,
  userCompanies: [],
  isSelectCompanyModalOpen: false,
};

export const appReducer = createReducer(
  initialState,

  /**
   *
   * used to control the side-menu: minimize and maximize
   */
  on(AppActions.minimizeSideMenu, (state) => ({
    ...state,
    sideMenuMinimized: true,
  })),
  on(AppActions.maximizeSideMenu, (state) => ({
    ...state,
    sideMenuMinimized: false,
  })),

  /**
   *
   * Attempt to create a global modal state - potentially obsolete
   */
  on(AppActions.openAModal, (state) => ({
    ...state,
    isAModalOpen: true,
  })),
  on(AppActions.closeAModal, (state) => ({
    ...state,
    isAModalOpen: false,
  })),

  /**
   * Set companies
   */

  on(AppActions.setCompanies, (state, { companies }) => ({
    ...state,
    userCompanies: companies,
  })),

  /**
   * Choose the  active company - in the top dropdown
   */

  on(AppActions.chooseCompany, (state, { companyId }) => ({
    ...state,
    currentCompany: companyId,
  })),

  /**
   *
   * Show the select company modal when user logs in and
   * a company is not selected
   */
  on(AppActions.openSelectCompanyModal, (state) => ({
    ...state,
    isSelectCompanyModalOpen: true,
  })),
  on(AppActions.closeSelectCompanyModal, (state) => ({
    ...state,
    isSelectCompanyModalOpen: false,
  }))
);
